<template>
    <div id="FAQ" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="faqHeader" v-if="$route.params.id > 0">Update FAQ</span>
                    <span class="page-title" id="faqHeader" v-else>Add FAQ</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackfaqList">
                        <i class="fp-back"> </i>    Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content faq-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal form-custom-select basic-form-container" id="faqForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Module : </label>
                                        <v-select placeholder="Select Module" v-model="moduleId" label="text" :options="moduleArr"></v-select>
                                        <div class="field-error">{{ module_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require">Question</th>
                                                <th scope="col" class="require">Answer</th>
                                                <th scope="col"> Action </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">
                                                <td>
                                                    <input type="textarea" class="form-control" v-model="row.question" placeholder="Enter Question">
                                                    <div class="field-error">{{ row.question_error }}</div>
                                                </td>    
                                                <td>
                                                    <input type="textarea" class="form-control" v-model="row.answer" placeholder="Enter Answer">
                                                    <div class="field-error">{{ row.answer_error }}</div>
                                                </td>        
                                                <td class="text-center valign-middle">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0)" v-on:click="removeRow(index,row.id);"><i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="btn-groups">
                                        <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                            <i class="fp-add"></i> Add Line Item
                                        </button>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                        <div class="field-error">{{ error_msg }}</div>
                                    </div>
                                </div>
                                <div class="btn-groups mt-4">
                                    <button type="submit" id="faqBtn" class="btn btn-primary" v-if="$route.params.id > 0" v-on:click.prevent="addrecord">
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="faqBtn" class="btn btn-primary" v-else v-on:click.prevent="addrecord">
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinuefaqBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="addrecord(flag='Save and Continue')">
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelfaqBtn" class="btn btn-tertiary" v-on:click.prevent="BackfaqList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>   
                    </div>
                </div>            
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
import EventBus from "./event-bus";
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
export default {
    name: "FAQ",
    
    metaInfo() {
        return {title: "FAQ Create | " +process.env.COPYRIGHT_NAME}
    },
    mixins:[commonMixins],
    data: () => ({
        recordId:0,
        agreementId:"",
        disableAgreement:false,
        truckType: null,
        truckSelect: [{
            value: "", text: "Select Truck" 
        }],
        sectionRateId: null,
        sectionArr: [],
        rate: "",
        query: "",
        title: "Add",
        results: [],
        type_rate: "day",
        type_id: "",
        rental_rate_id: 0,
        cancelbtn: false,
        formerrors: [],
        msgClass: "",
        button_text: "Add",
        cantAccessPage:"",
        permissions:[],
        error_msg:"",
        agreementError: "",
        truckTypeError: "",
        rateerrors: "",
        ratetypeerrors: "",
        sectionerrors: "",
        loading:false,
        disableTruckType:false,
        moduleArr:[],
        rows:[{
            id:0,
            question: "",
            question_error: "",
            answer:"",
            answer_error:"",
        }],
        moduleId:'',
        module_error_msg:"",
    }),

    watch:{

        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'add_faq') {
                    self.cantAccessPage = true;

                }

            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        },
    },

    mounted: function() {

        var self = this;

        self.getModules();
        self.getPermissions();
        
        setTimeout(function () {
            
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3]) {
                self.recordId = segments[3];
                self.loadFaq(self.recordId);
            }
        }, 100);
        
    },

    methods: {

        addRow: function () {

            var self = this;
            var index = self.rows.length - 1;

            self.rows[index].question_error = "";
            self.rows[index].answer_error = "";
            

            if ( self.rows[index].question != "" && self.rows[index].answer != "") {
                        
                self.rows.push({
                    id:0,
                    question: "",
                    question_error: "",
                    answer:"",
                    answer_error:"",
                });

            } else {
                
                if (self.rows[index].question == '' || !self.rows[index].question ) {
                    self.rows[index].question_error = "Question required.";
                }
                if (self.rows[index].answer == '' || !self.rows[index].answer ) {
                    self.rows[index].answer_error = "Answer required.";
                }
            }
        },
        removeRow: function (index,rowId) {
            
            var self = this;
            
            if ( rowId == 0 ) {
                self.rows.splice(index, 1);

            } else {
                
                if ( confirm('Are you sure that you want to delete this Row? ')) {

                    $.ajax({
                        url: process.env.ROOT_API + "/faq/delete",
                        type: "POST",
                        data: {id: rowId},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            
                            if (data.status == "success") {
                                self.rows.splice(index, 1);
                            }

                        },
                        error: function (jqXHR, exception) {
                            self.generateStatusCodeMessage(jqXHR,true,'faq-delete')
                        },
                    });
                }
            }
            
        },
        getModules() {
            var self = this;
            self.loading = true;
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/get-modules",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                   flag:'all' 
                },
                success: function (data) {
                    self.loading = false;
                    self.moduleArr = data.content;
                    console.log(data);
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'faq-get-modules')
                }
            });
        },

        BackfaqList() {
            var self = this;
            self.$router.push("/faq/list");
        },

        addrecord(flag) {

            var self = this;

            self.module_error_msg =  "";
            
            var error = false;

            if ( self.moduleId == null || !self.moduleId.value ) {
                self.module_error_msg = "Module required.";
                error = true;
            }

            for ( var i = 0; i < self.rows.length; i++ ) {
                // console.log(self.rows[i]);
                self.rows[i].question_error = "";
                self.rows[i].answer_error = "";
                var tempError = 0;

                if ( self.rows[i].question == null || self.rows[i].question == '' ) {
                    self.rows[i].question_error = "Question required.";
                    error = true;
                    tempError = 1;
                }

                if ( self.rows[i].answer == null || self.rows[i].answer == '' ) {
                    self.rows[i].answer_error = "Answer required.";
                    error = true;
                    tempError = 1;
                }
            }

            if ( !error ) {

                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[3])
                {
                    $("#faqBtn").val("Updating ...");
                    $("#faqBtn").prop("disabled", true);
                    $("#cancelfaqBtn").prop("disabled",true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinuefaqBtn").val("Saving ...");
                        $("#faqBtn").prop("disabled", true);
                        $("#createAndContinuefaqBtn").prop("disabled", true);
                        $("#cancelfaqBtn").prop("disabled",true);

                    }else{

                        $("#faqBtn").val("Saving ...");
                        $("#faqBtn").prop("disabled", true);
                        $("#createAndContinuefaqBtn").prop("disabled", true);
                        $("#cancelfaqBtn").prop("disabled",true);
                    }
                
                }
                
                var fields = $("#faqForm").serializeArray();
                fields.push({name: "id", value: segments[3]});
                if ( self.agreementId == null ) {
                    fields.push({name: "module_id", value: ""});
                }else{
                    fields.push({name: "module_id", value: self.moduleId.value});
                }
                fields.push({name: "rows", value: JSON.stringify(self.rows)});
                
                $.ajax({
                    url: process.env.ROOT_API + "/faq/create",
                    type: "POST",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:'json',
                    data: fields,
                    success: function(data) {
                        self.loading = false;
                        if (segments[3])
                        {
                            $("#faqBtn").val("Update");
                            $("#faqBtn").prop("disabled", false);
                            $("#cancelfaqBtn").prop("disabled",false);
                        } else {

                            if (flag == "Save and Continue") {

                                $("#createAndContinuefaqBtn").val("Save and Continue");
                                $("#faqBtn").prop("disabled", false);
                                $("#createAndContinuefaqBtn").prop("disabled", false);
                                $("#cancelfaqBtn").prop("disabled",false);

                            }else{

                                $("#faqBtn").val("Save");
                                $("#faqBtn").prop("disabled", false);
                                $("#createAndContinuefaqBtn").prop("disabled", false);
                                $("#cancelfaqBtn").prop("disabled",false);

                            }
                        }
                        if (data.status == "success") {
                        
                            if (flag == "Save and Continue") {
                                self.moduleId = null;
                                self.rows = [];
                                self.rows.push({
                                    id:0,
                                    question: "",
                                    answer: "",
                                    question_error:"",
                                    answer_error:"",
                                });

                            } else {
                                self.$router.push("/faq/list");
                            }
                        
                        } else {

                            if (data.content.length > 0) {
                                var err = "";
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                        
                    },
                    error: function(jqXHR, exception) {

                        self.loading = false;
                        if (segments[3]) {
                            $("#faqBtn").val("Update");
                            $("#faqBtn").prop("disabled", false);
                            $("#cancelfaqBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#customerScopeRateForm").trigger("reset");
                                $("#createAndContinuefaqBtn").val("Save and Continue");
                                $("#faqBtn").prop("disabled", false);
                                $("#createAndContinuefaqBtn").prop("disabled", false);
                                $("#cancelfaqBtn").prop("disabled",false);

                            } else{

                                $("#faqBtn").val("Save");
                                $("#faqBtn").prop("disabled", false);
                                $("#createAndContinuefaqBtn").prop("disabled", false);
                                $("#cancelfaqBtn").prop("disabled",false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'faq-create')
                    }
                });

            } else {
                console.log($(".error_style").length);
                self.msgClass = "error";
                self.errorValidationFocus();
            }
        },

        loadFaq(id) {

            var self = this;
            self.loading = true;
            
            $.ajax({
                url: process.env.ROOT_API + "/faq/fetch",
                type: "POST",
                crossDomain: true,
                data:{
                    id:id
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function(data) {
                    self.loading = false;
                    if (data.status == "success") {

                        self.moduleId = {text:data.content.module_name,value:data.content.module_id};
                        self.$set(self.rows,0,{
                            id:data.content.id,
                            question:data.content.question,
                            answer:data.content.answer,
                            question_error:'',
                            answer_error:'',
                        }) 
                        // if ( data.content.length ) {
                        //     self.rows = data.content.items;
                        // }
                    }
                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'faq-fetch-by-id')
                }
            });
        },

        // String Upper Case //
        jsUcfirst: function(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        isNumberCheck: function(evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/FAQ.vue